import { render, staticRenderFns } from "./TextareaCkeditor.vue?vue&type=template&id=30dcce6c"
import script from "./TextareaCkeditor.vue?vue&type=script&lang=js"
export * from "./TextareaCkeditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../gestion-tache-vuejs-v2/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports